import axios from 'axios';
import { API } from '../../../lib/api/api';

export const postToInstagram = async (
	userId: string,
	accessToken: string,
	containerId: number,
	isScheduled: boolean,
	utcTime: string,
	auth0userId: string,
	imageUrl: string,
	caption: string,
	profileName: string
) => {
	try {
		const res = await axios.get(
			`${API}instagram/publishMediaContainer/${userId}?userId=${userId}&accessToken=${accessToken}&containerId=${containerId}&utcTime=${utcTime}&auth0userId=${auth0userId}&isScheduled=${isScheduled}&imageUrl=${imageUrl}&caption=${caption}&profileName=${profileName}`
		);
		return res;
	} catch (e) {
		return {
			error: e,
			status: 'error',
			statusText:
				'Oops! Your post was not sent. Try again, and please contact support if this issue persists.',
			data: e
		};
	}
};
